module.exports = __webpack_public_path__ + "static/media/part-2.26fa7a26.webp";